export default __webpack_public_path__ + "static/media/old_newspapers.3a276c8e.png";